import { DataGrid, GridRenderCellParams, ukUA } from '@mui/x-data-grid';
import * as React from 'react';
import moment from 'moment';
import MenuIcon from '@mui/icons-material/Menu';
import { style } from '../../../../common/DataTable/style';
import styles from './styles.module.scss';
import { InvoiceDetailsModal } from './InvoiceDetailsModal';
import useModal from '../../../../shared/hooks/useModal/useModal';

interface Props {
  data: any;
}

export const InvoicesReportTable: React.FC<Props> = ({ data }) => {
  const [pageSize, setPageSize] = React.useState(50);
  const [selectedRow, setSelectedRow] = React.useState<any>();
  const { isShow, openModal, closeModal } = useModal();
  const [selectedRowCountry, setSelectedRowCountry] = React.useState<any>();

  return (
    <div style={{ height: 580, width: '100%', marginTop: '20px' }}>
      <DataGrid
        localeText={ukUA.components.MuiDataGrid.defaultProps.localeText}
        rows={data}
        headerHeight={34}
        rowHeight={34}
        columns={[
          { field: 'number', headerName: 'Номер накладної', width: 180 },
          {
            field: 'createDate',
            headerName: 'Дата і час створення',
            width: 160,
            renderCell: (params: GridRenderCellParams<Date>) => (
              <span>{moment(params.row.createDate).format('DD-MM-YYYY HH:mm:ss')}</span>
            ),
          },
          {
            field: 'invoiceDate',
            headerName: 'Дата накладної',
            width: 160,
            renderCell: (params: GridRenderCellParams<Date>) =>
              params.row.invoiceDate ? <span>{moment(params.row.invoiceDate).format('DD-MM-YYYY')}</span> : '',
          },
          { field: 'boxesCount', headerName: 'Кількість ящиків.', width: 160 },
          { field: 'countryCode', headerName: 'Країна', width: 80 },
          { field: 'counterparty', headerName: 'Назва отримувача', minWidth: 160, flex: 1 },
          {
            field: 'button',
            headerName: 'Меню',
            headerAlign: 'center',
            width: 60,
            align: 'center',
            renderCell: (params: GridRenderCellParams<Date>) => (
              <MenuIcon
                className={styles.icon}
                onClick={() => {
                  setSelectedRow({ documentShippingId: params.row.id });
                  setSelectedRowCountry({ countryCode: params.row.countryCode });
                  openModal();
                }}
              />
            ),
          },
        ]}
        disableSelectionOnClick
        disableColumnMenu
        disableColumnSelector
        sx={style}
        pageSize={pageSize}
        onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
        pagination
        componentsProps={{
          pagination: {
            SelectProps: {
              MenuProps: {
                sx: {
                  '& .MuiMenuItem-root': {
                    fontSize: 14,
                    bgcolor: '#ffffff',
                  },
                },
                PaperProps: {
                  sx: {
                    bgcolor: '#ffffff',
                  },
                },
              },
            },
          },
        }}
      />

      <InvoiceDetailsModal isShown={isShow} closeModal={closeModal} params={selectedRow} country={selectedRowCountry} />
    </div>
  );
};
